import { log } from '../../util/log';
import { BookingContext } from '../../util/booking-context';
import { callWp } from '../../util/call-wp';
import { hideLoadingOverlay, showLoadingOverlay } from '../../util/loading-overlay';
import { track } from '../../util/tracking';

export async function loadBookingConfirmedPage(context: BookingContext) {
	window.scroll(0, 0);
	log('Loading booking confirmed page');
	showLoadingOverlay(context);
	context.root.innerHTML = '';
	const ssrStartTime = performance.now();
	const ssrResponse = await callWp('GET', 'view_booking_confirmed', context.data);
	const ssrEndTime = performance.now();
	log('SSR took', ssrEndTime - ssrStartTime, 'ms');
	const { html, trackingData: ssrTrackingData } = ssrResponse;
	context.root.innerHTML = html;
	hideLoadingOverlay(context);

	context.root
		.querySelectorAll<HTMLButtonElement>('button[data-reload]')
		.forEach((b) => b.addEventListener('click', () => loadBookingConfirmedPage(context)));

	track({
		event: 'pageview',
		page_location: '/booking-online/booking-confirmed/',
		page_title: 'Booking online - 5 - Booking Confirmed',
	});
	track({
		event: 'bookingConfirmed',
		...(ssrTrackingData ?? {}),
	});
}
